import { Fragment } from "react";

import { useServerSideProps } from "~/contexts/server-side-props";
import { useCart } from "~/hooks/use-cart";
import Editorials from "~/types/editorials";
import { assertEditorialType } from "~/utils/editorial-utils";

import CartPickProductBlock from "./cart-pick-product-block";
import styles from "./cart-pick-product-section.module.scss";

type Props = {
  inCheckout?: boolean;
  onClose?: () => void;
};

export default function CartPickProductSection(props: Props) {
  const cart = useCart();
  const { serverSideProps } = useServerSideProps();

  const contentUtils = serverSideProps.contentUtils;
  assertEditorialType<Editorials.ContentUtils>(contentUtils, "contentUtils");

  const hidePickProductPromotionAtCheckout = contentUtils.fields.hidePickProductPromotionAtCheckout;

  if (!cart?.AdditionalOrderData?.DiscountPickProductOptions) {
    return null;
  }

  const arrayDiscountPickProductOptions = Object.entries(cart.AdditionalOrderData.DiscountPickProductOptions).sort(
    ([lineA], [lineB]) => lineA.localeCompare(lineB)
  );

  let listPickProductPromotionGuest: boolean[] = [];

  if (props.inCheckout) {
    listPickProductPromotionGuest = arrayDiscountPickProductOptions.map(([line]) => {
      const promoBackendId = cart?.ShoppingCart.Lines.find((el) => `${el.ID}` == line)?.DiscountBackendID;

      return (
        !!promoBackendId &&
        !!hidePickProductPromotionAtCheckout &&
        hidePickProductPromotionAtCheckout.includes(promoBackendId)
      );
    });

    if (listPickProductPromotionGuest.filter((pickProductPromotion) => !pickProductPromotion).length === 0) {
      props.onClose?.();
    }
  }

  return (
    <div className={styles.container}>
      {arrayDiscountPickProductOptions.map(([line, option], index) => {
        const cartOption = cart.AdditionalOrderData?.DiscountPickProductOptions?.[+line];
        const currentSelection = cartOption?.CurrentSelection;

        // in checkout - we want to show all pick product promotion for the logged in user
        if (props.inCheckout) {
          if (!listPickProductPromotionGuest[index]) {
            return <CartPickProductBlock key={line} line={line} option={option} currentSelection={currentSelection} />;
          } else {
            return <Fragment key={line} />;
          }
        } else {
          return <CartPickProductBlock key={line} line={line} option={option} currentSelection={currentSelection} />;
        }
      })}
    </div>
  );
}
